"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentsPreviewMappers = void 0;
var componentExtensions_1 = require("./componentExtensions");
// import * as SlideShowGallery from './components/SlideShowGallery/SlideShowGallery.previewMapper'
exports.componentsPreviewMappers = __assign({}, componentExtensions_1.componentsMappers);
//# sourceMappingURL=componentPreviewExtensions.js.map